
import {
  API_CREATE_PRIVACY_POLICY,
  API_GET_PRIVACY_POLICY,
  API_UPDATE_PRIVACY_POLICY,
  API_LIST_PRIVACY_POLICY,
} from "api/privacy-policy"; // Update your imports accordingly
// import { API_LIST_PRIVACY_POLICY } from "api/privay-policy";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the styles
import { toast } from "react-toastify";

const PrivacyPolicy = () => {
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [policyId, setPolicyId] = useState(null); // Track the policy ID if updating
const {t} = useTranslation();
  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const response = await API_LIST_PRIVACY_POLICY(); // Make sure your API returns data in the expected format
        if (response) {
          console.log("response", response);
          const policy = response.privacyPolicy?.[0];
          console.log("policy ==>", policy);

          setTitle(policy?.subject);
          setContent(policy?.paragraph);
          setPolicyId(policy?._id); // Assume the policy object has an id
          setIsUpdating(true);
        }
      } catch (error) {
        console.error("Failed to fetch privacy policy", error);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  const handleChange = (value) => {
    setContent(value);
  };

  const handleSave = async () => {
    try {
      const payload = {
        subject: title,
        paragraph: content,
      };
      let userData;
      if (isUpdating) {
        // Call the update API
        userData = await API_UPDATE_PRIVACY_POLICY(policyId, payload);
      } else {
        // Call the create API
        userData = await API_CREATE_PRIVACY_POLICY(payload);
      }

      toast.success(userData?.message);
      // Navigate("/admin/catagory/catagory-tables");
    } catch (error) {
      console.error("Error saving policy", error);
      toast.error(error?.response?.data?.errors?.name);
    }
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ["link", "image", "video"],
      ["clean"], // remove formatting button
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "align",
    "color",
    "background",
    "link",
    "image",
    "video",
    "indent",
    "direction",
  ];

  return (
    <div className="ml-2">
      {/* <h1>Edit Privacy Policy</h1> */}
      <input
        className="mb-4 mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
        value={title}
        onChange={(e) => {
          setTitle(e.target.value);
        }}
        placeholder={t("Subject")}
      />
      <ReactQuill
        value={content}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder="Content"
      />
      <div className="flex justify-end">
        <button
          type="submit"
          className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          onClick={handleSave}
        >
          {t("Save And Update")}
        </button>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
